export const isDebugMode = () => typeof window !== 'undefined' && window.location.search.indexOf('gadebugmode=true') !== -1;